import { useState, useCallback } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { style } from './style.js';
import Cookies from 'js-cookie';

export default function nwsFetch(url, _data, setError){
	setError = setError || console.log;
	let data = {
		..._data,
		headers: {
			"X-csrftoken": Cookies.get("csrftoken"),
			..._data.headers,
		},
	}
	if(!(data.body instanceof FormData)){
		data.headers["Content-Type"] = "application/json";
	}
	const requestPromise = fetch(url, data);
	requestPromise.then(async (request) => {
		if(!request.ok){
			const errorMessage = await request.clone().json();
			setError(errorMessage);
		}
	});
	return requestPromise;
}

export function ErrorMessage({currentError, setError}){
  return (
      <Modal
        open={currentError !== ""}
        onClose={() => setError("")}
      >
        <Box sx={style}>
         <Typography>{currentError}</Typography> 
        </Box>
      </Modal> 
  );
}

export function useNwsFetch(){
  const [error, _setError] = useState("");
  const setError = useCallback((err) => {
    if(err.hasOwnProperty("detail")){
      _setError(err["detail"]);
    }else if(err.hasOwnProperty("non_field_errors")){
      _setError(err["non_field_errors"]);
    }else{
      _setError(err);
    }
  }, [_setError]);
  const fetcher = useCallback((url, _data={}) => {
    return nwsFetch(url, _data, setError);
  }, [setError]);
  return [
    fetcher,
    (<ErrorMessage currentError={error} setError={setError}/>)
  ];
}
